import React from 'react'
import { SelectField, SelectFieldProps } from 'scenes/Dashboard/components-next/Forms/Controllers'

import { UserStatus } from '../../../../../../../../../entities-next/user'

export type UserStatusSelectProps = Omit<SelectFieldProps, 'options' | 'getOptionLabel'>

const userStatusOptions = Object.values(UserStatus)

const userStatusLabelEquivalence: { [key in UserStatus]: string } = {
  [UserStatus.active]: 'Active',
  [UserStatus.churned]: 'Churned',
  [UserStatus.zombie]: 'Zombie',
  [UserStatus.onHold]: 'On hold',
}

export function UserStatusSelect(selectProps: UserStatusSelectProps) {
  return (
    <SelectField
      options={userStatusOptions}
      getOptionLabel={(value) => userStatusLabelEquivalence[value]}
      {...selectProps}
    />
  )
}
